import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDark: !!JSON.parse(localStorage.getItem('dark-mode')),
            // Index of the word currently shown in the animated title rotator.
            wordIndex: 0,
        };
        this.ROTATING_WORD_KEYS = ['brands', 'products', 'customers'];
        this.WORD_INTERVAL_MS = 2200;
    }

    componentDidMount() {
        // Cycle the highlighted word (brands -> products -> customers -> ...).
        this.wordTimer = setInterval(() => {
            this.setState((prev) => ({
                wordIndex: (prev.wordIndex + 1) % this.ROTATING_WORD_KEYS.length,
            }));
        }, this.WORD_INTERVAL_MS);
    }

    componentWillUnmount() {
        clearInterval(this.wordTimer);
    }

    render() {
        const { t } = this.props;
        const bannerBg = '/static/img/banner-full.png';

        // Seven curved connection lines that sweep from the left and converge
        // toward the card on the right. Geometry is authored in the SVG's
        // 1040x400 viewBox; each line is drawn once (in <defs>) and reused for
        // both the faint visible stroke and the moving dots.
        const connectionLines = [
            {
                id: 'ai-line-1',
                d: 'M 440 55 C 480 205 500 250 610 360',
                color: 'rgba(147, 197, 253, 0.9)',
            },
            { id: 'ai-line-2', d: 'M 460 42 C 500 192 525 260 635 370', color: '#f7871f' },
            {
                id: 'ai-line-3',
                d: 'M 478 33 C 518 183 548 267 658 377',
                color: 'rgba(255, 255, 255, 0.9)',
            },
            { id: 'ai-line-4', d: 'M 495 30 C 535 180 570 270 680 380', color: '#4f9dff' },
            {
                id: 'ai-line-5',
                d: 'M 512 34 C 552 184 592 266 702 376',
                color: 'rgba(147, 197, 253, 0.85)',
            },
            {
                id: 'ai-line-6',
                d: 'M 528 44 C 568 194 614 258 724 368',
                color: 'rgba(255, 255, 255, 0.8)',
            },
            {
                id: 'ai-line-7',
                d: 'M 545 58 C 585 208 636 247 746 357',
                color: 'rgba(148, 163, 184, 0.85)',
            },
        ];
        const DOTS_PER_LINE = 3;
        const DOT_DURATION = 4.2; // seconds for one dot to travel the full line

        return (
            <div
                className="ai-tracking-banner"
                style={{
                    backgroundImage: `url("${bannerBg}")`,
                }}
            >
                {/* Animated connection lines behind the card. Decorative only. */}
                {/* <svg
                    className="ai-tracking-banner__lines"
                    viewBox="0 0 1040 400"
                    preserveAspectRatio="none"
                    aria-hidden="true"
                >
                    <defs>
                        <filter id="ai-dot-glow" x="-250%" y="-250%" width="600%" height="600%">
                            <feGaussianBlur stdDeviation="2.4" result="blur" />
                            <feMerge>
                                <feMergeNode in="blur" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                        {connectionLines.map((line) => (
                            <path key={line.id} id={line.id} d={line.d} />
                        ))}
                    </defs>

                    {connectionLines.map((line) => (
                        <use
                            key={`stroke-${line.id}`}
                            xlinkHref={`#${line.id}`}
                            fill="none"
                            stroke={line.color}
                            strokeWidth="1.4"
                            strokeOpacity="0.22"
                            strokeLinecap="round"
                        />
                    ))}

                    {connectionLines.map((line) =>
                        Array.from({ length: DOTS_PER_LINE }).map((_, i) => {
                            const begin = `${(i * DOT_DURATION) / DOTS_PER_LINE}s`;
                            return (
                                <circle
                                    key={`dot-${line.id}-${i}`}
                                    r="3.4"
                                    fill={line.color}
                                    filter="url(#ai-dot-glow)"
                                    opacity="0"
                                >
                                    <animateMotion
                                        dur={`${DOT_DURATION}s`}
                                        begin={begin}
                                        repeatCount="indefinite"
                                        rotate="0"
                                    >
                                        <mpath xlinkHref={`#${line.id}`} />
                                    </animateMotion>
                                    <animate
                                        attributeName="opacity"
                                        values="0;1;1;0"
                                        keyTimes="0;0.12;0.82;1"
                                        dur={`${DOT_DURATION}s`}
                                        begin={begin}
                                        repeatCount="indefinite"
                                    />
                                </circle>
                            );
                        }),
                    )}
                </svg> */}
                <div className="ai-tracking-banner__content">
                    <span className="ai-tracking-banner__badge">
                        <img
                            src="/static/img/ai-tracking-icon-green.svg"
                            alt=""
                            className="ai-tracking-banner__badge-icon"
                        />
                        {t('page_all_domain.messages.ai_tracking_banner.badge')}
                    </span>
                    <h2 className="ai-tracking-banner__title">
                        <span className="ai-tracking-banner__title-top">
                            {t('page_all_domain.messages.ai_tracking_banner.title_prefix')}
                            <span className="ai-tracking-banner__highlight">
                                {t('page_all_domain.messages.ai_tracking_banner.title_highlight')}
                            </span>
                        </span>
                        <span className="ai-tracking-banner__title-bottom">
                            {t('page_all_domain.messages.ai_tracking_banner.title_line_2')}{' '}
                            {/* The last word animates in each time it changes.
                                Keying the span by wordIndex remounts it so the
                                entrance keyframe replays on every swap. */}
                            <span className="ai-tracking-banner__rotator">
                                <span
                                    key={this.state.wordIndex}
                                    className="ai-tracking-banner__word"
                                >
                                    {t(
                                        `page_all_domain.messages.ai_tracking_banner.rotating_words.${
                                            this.ROTATING_WORD_KEYS[this.state.wordIndex]
                                        }`,
                                    )}
                                </span>
                            </span>
                        </span>
                    </h2>
                    <p className="ai-tracking-banner__subtitle">
                        {t('page_all_domain.messages.ai_tracking_banner.subtitle')}
                    </p>
                    <a className="ai-tracking-banner__button" href="/customers/legacy-ai-upgrade/">
                        {t('page_all_domain.messages.ai_tracking_banner.button')}
                    </a>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Banner);
